import React from 'react'

import withFade from '../../HOC/withFade'
import withQuestion from '../../HOC/withQuestion'
import { LoanAmountQuestion as LoanAmountQuestionV2 } from './LoanAmountQuestion.v2'
import QuestionComponentProps from '../../../Questions/question-component-props'

export const LoanAmountQuestion = withFade(withQuestion((props: QuestionComponentProps) => {
  return  <LoanAmountQuestionV2 {...props} />
}))
